import React from 'react';
import AnswerFilter from '../../../ui/src/app/main/analytics/student/AnswerFilter';
import { QuestionProvider } from "../../../sk-doc/src/QuestionContext";
import SKDoc from '../../../sk-doc/src/SKDoc';
import { checkExistSolveIndex } from "../../../sk-doc/src/utils/data";
import './styles.scss';
import ScrollToTop from '../../../common-sk-doc/src/components/ScrollToTop';
import SVG from 'react-inlinesvg';
import config from '../../../common-sk-doc/src/config';

const SkillQuestionShowSSR: React.FC<{ pageInfo: any, questionData: any, level: any }> = ({ pageInfo, questionData, level }) => {
  return (
    <>
      <QuestionProvider>
        <div className='skill-page'>
          <div className={`grade-${level < 6 ? level : 'default'}-size`}>
            <div className="container" >
              {questionData?.content?.children?.length > 0 && (
                <>
                  <hr />
                  {/* <b>{
                  'Nội dung câu hỏi'
                  // Translate('question-content', 'Nội dung câu hỏi')
                }</b> */}
                  <div>
                    <SKDoc element={questionData?.content} />
                  </div>
                </>
              )}

              {questionData?.remember?.children?.length > 0 && (
                <>
                  <hr />
                  <b>{'Ghi nhớ' /*Translate('remember', 'Ghi nhớ')*/}</b>
                  <SKDoc element={questionData?.remember} />
                </>
              )}

              {!checkExistSolveIndex(questionData) && (
                <>
                  <hr />
                  <b>{'Đáp án' /*Translate('correct-answer', 'Đáp án')*/}</b>
                  <div style={{ background: '#e3f7ff' }}>
                    <QuestionProvider>
                      <AnswerFilter
                        data={questionData.content}
                        correctAnswer={questionData.correctAnswer}
                        isContainer={false}
                      />
                    </QuestionProvider>
                  </div>
                </>
              )}

              {questionData?.solve?.children?.length > 0 && (
                <>
                  <hr />
                  <b>{'Giải thích' /*Translate('explain', 'Giải thích')*/}</b>
                  <div style={{ background: '#e3f7ff' }}>
                    <SKDoc element={questionData?.solve} />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </QuestionProvider>
      <div className='fixed-bottom'>
        <NextBackController pageInfo={pageInfo}/>
      </div>
      <ScrollToTop />
    </>
  );
};


const NextBackController: React.FC<{ pageInfo?: any }> = ({ pageInfo }) => {
  const {
    totalPage,
    indexPage,
    nextUrl,
    previousUrl,
  } = pageInfo || {};

  const isNextScope = indexPage === totalPage - 1;
  const isPreviousScope = indexPage === 0;

  return (
    <div className="d-flex next-back-button-controller">
      <a
        title={`${isPreviousScope ? 'Về kiến thức/kỹ năng trước' : 'Về câu trước'}`}
        className={`back-btn${previousUrl != null ? '' : ' disable'}`}
        href={previousUrl}
      >
        <SVG
          src={
            config.ASSETS_PATH + `/images/skill/teacher-toolbar/${isPreviousScope ? 'back-skill-hide.svg' : 'back-hide.svg'}`
          }
        />
      </a>
      <div className="question-index-info">
        <span>
          {indexPage + 1}/{totalPage}
        </span>
      </div>
      <a
        title={`${isNextScope ? 'Đi tới kiến thức/kỹ năng tiếp theo' : 'Đi tới câu sau'}`}
        className={`next-btn${nextUrl != null ? '' : ' disable'}`}
        href={nextUrl}
      >
        <SVG
          src={
            config.ASSETS_PATH + `/images/skill/teacher-toolbar/${isNextScope ? 'next-skill-hide.svg' : 'next-hide.svg'}`
          }
        />
      </a>
    </div>
  );
}

export default SkillQuestionShowSSR;
